import React, { useRef, useEffect, useState } from "react";
import Banner from './components/banner';
import Video from './components/video';
import Gallery from './components/gallery';
import Contact from './components/contact';
import channelData from './channelData';
import './assets/css/default.css'
import './assets/css/layout.css'
import './assets/css/responsive.css'
import './App.css';

const getDimensions = ele => {
  const { height } = ele.getBoundingClientRect();
  const offsetTop = ele.offsetTop;
  const offsetBottom = offsetTop + height;

  return {
    height,
    offsetTop,
    offsetBottom,
  };
};

const scrollTo = ele => {
  ele.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

function App() {
  const [visibleSection, setVisibleSection] = useState();

  const headerRef = useRef(null);
  const homeRef = useRef(null);
  const videoRef = useRef(null);
  const galleryRef = useRef(null);
  const contactRef = useRef(null);

  const sectionRefs = [
    { section: "Home", ref: homeRef },
    { section: "Video", ref: videoRef },
    { section: "Gallery", ref: galleryRef },
    { section: "Contact", ref: contactRef },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const { height: headerHeight } = getDimensions(headerRef.current);
      const scrollPosition = window.scrollY + headerHeight;

      const selected = sectionRefs.find(({ ref }) => {
        const ele = ref.current;
        if (ele) {
          const { offsetBottom, offsetTop } = getDimensions(ele);
          return scrollPosition > offsetTop && scrollPosition < offsetBottom;
        }
      });

      if (selected && selected.section !== visibleSection) {
        setVisibleSection(selected.section);
      } else if (!selected && visibleSection) {
        setVisibleSection(undefined);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [visibleSection]);
  return (
    <React.Fragment>
      <header>
        <nav role="navigation" className="mobile-nav">
          <div id="menuToggle">
            <input type="checkbox" />
            <span></span>
            <span></span>
            <span></span>
            <ul id="menu" ref={headerRef}>
            <li><a
              className={visibleSection === "Home" ? "selected" : ""}
              onClick={() => {
                scrollTo(homeRef.current);
              }} href="#home">Home</a></li>
            <li><a
              className={visibleSection === "Video" ? "selected" : ""}
              onClick={() => {
                scrollTo(videoRef.current);
              }} href="#video">Youtube Videos</a></li>
            <li><a
              className={visibleSection === "Gallery" ? "selected" : ""}
              onClick={() => {
                scrollTo(galleryRef.current);
              }} href="#gallery">Photo Gallery</a></li>
            <li><a
              className={visibleSection === "Contact" ? "selected" : ""}
              onClick={() => {
                scrollTo(contactRef.current);
              }} href="#contact">Contact</a></li>
            </ul>
          </div>
        </nav>
        <nav className="main-nav">
          <ul id="nav" ref={headerRef}>
            <li><a
              className={visibleSection === "Home" ? "selected" : ""}
              onClick={() => {
                scrollTo(homeRef.current);
              }} href="#home">Home</a></li>
            <li><a
              className={visibleSection === "Video" ? "selected" : ""}
              onClick={() => {
                scrollTo(videoRef.current);
              }} href="#video">Youtube Videos</a></li>
            <li><a
              className={visibleSection === "Gallery" ? "selected" : ""}
              onClick={() => {
                scrollTo(galleryRef.current);
              }} href="#gallery">Photo Gallery</a></li>
            <li><a
              className={visibleSection === "Contact" ? "selected" : ""}
              onClick={() => {
                scrollTo(contactRef.current);
              }} href="#contact">Contact</a></li>
          </ul>
        </nav>
      </header>
      <section id="Home" ref={homeRef} className="h100v">
        <Banner channelData={channelData} />
      </section>
      <section id="Video" ref={videoRef} className="h100v">
        <Video channelData={channelData} />
      </section>
      <section id="Gallery" ref={galleryRef} className="h100v">
        <Gallery channelData={channelData} />
      </section>
      <section id="Contact" ref={contactRef} className="h100v">
        <Contact channelData={channelData} />
      </section>
    </React.Fragment>
  );
}

export default App;
